import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Switch from "@mui/material/Switch";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useDefaultQuoteSettingsContext} from "../../contexts/DefaultQuoteSettingsContext";

export const DefaultSettingsRebatesTax = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { quoteSettings, setSettingsStateWithUpdate } = useDefaultQuoteSettingsContext()

    return (
        <TableRow
            key={'Sales Tax'}
            sx={{
                '&:last-child td, &:last-child th': {border: 0},
                height: '10px',
                background: '#F0F6FA'
            }}
            className={'default-settings-fee'}
        >

            <TableCell
                className={'DealPageFee fee-name'}
                scope="row"
                size={'small'}
                width={'60%'}
                align="left"
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: "row",
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    Rebates Tax
                </div>
            </TableCell>
            <TableCell
                className={'DealPageFee'}
                align="right"
                size={'small'}
                width={'20%'}
            >
                <Switch
                    checked={quoteSettings.is_rebate_tax_capped}
                    onChange={() => {
                        setSettingsStateWithUpdate({is_rebate_tax_capped: !quoteSettings.is_rebate_tax_capped}, true)
                    }}
                />

            </TableCell>
        </TableRow>
    )
}